<div [ngClass]="popupOptions.rootClass">
  <div
    class="modal-close extend-click-area"
    (click)="close()">
    <app-icon name="close"></app-icon>
  </div>

  <ng-container *transloco="let t">
    <div class="modal-header">
      <app-icon
        *ngIf="popupOptions.rootClass === 'danger'"
        name="modal-danger"></app-icon>
      <h3
        class="modal-title"
        [innerHTML]="t(popupOptions.titleKey || 'modal.default-title')">test</h3>
    </div>

    <div class="modal-body">
      <span [innerHTML]="t(popupOptions.descriptionKey || 'modal.default-description', popupOptions.descriptionValues)"></span>

      <div style="margin-top: 24px">
        <button
          [ngClass]="popupOptions.agreeButtonClasses"
          (click)="confirm()"
          ngPreserveWhitespaces>
          <app-icon
            *ngIf="popupOptions.agreeButtonIcon"
            [name]="popupOptions.agreeButtonIcon"></app-icon>
          {{ t(popupOptions.agreeButtonKey) }}
        </button>
        <button
          class="btn __l __clear"
          (click)="close()"
          [innerHTML]="t(popupOptions.declineButtonKey)"></button>
      </div>
    </div>
  </ng-container>
</div>
